import React, { useState } from 'react';
import EcardEditFileModal from '../ECardEditFile/ECardEditFileModal';
import { joinClasses } from '../../../../Utils/className.util';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import AntivirusCheck from '../../../../Components/Base/Loading/AntivirusCheck';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import { prepareDocumentationFileForMediaViewer } from '../../Services/eCardFile.service';
import { useAppContext } from '../../../../Services/AppContext';
import { DocumentationFile } from '../../../../graphql/graphql';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import { FileToShare } from '../ECard/ECard';

// @ts-ignore
import styles from './ECardGridItem.module.scss';
import MultiMediaViewerModal from '../../../Base/Components/MultiMediaViewer/MultiMediaViewerModal';
import { IMultiMediaViewerItem } from '../../../Base/Components/MultiMediaViewer/MultiMediaViewerItem';

interface Props {
	item: DocumentationFile;
	reloadData: (folderId: string, needReload: boolean) => void;
	isShareMode: boolean;
	onCheck: (file: FileToShare, isChecked: boolean) => void;
	isSelected: boolean;
	canBeEdited: boolean;
}

const ECardGridItem: React.FC<Props> = ({
	item,
	reloadData,
	isShareMode,
	onCheck,
	isSelected,
	canBeEdited,
}) => {
	const [isEditOpen, setIsEditOpen] = useState(false);
	const [isFileOpen, setIsFileOpen] = useState(false);
	const { socketUrl } = useAppContext();

	const handleCheck = () => {
		onCheck({ id: item.id, name: item.name ?? '', file: item }, !isSelected);
	};

	const hasGroupFiles = (item.groupFiles?.length || 0) > 0;

	return (
		<>
			<div className={'col-lg-3 col-md-4 col-12'}>
				{item.avResult === 'clean' && (
					<div className={styles.wrapper}>
						{item.hasThumb && item?.thumbUrl && item?.name && (
							<div onClick={() => setIsFileOpen(true)}>
								<img src={item.thumbUrl} alt={item.name} />
							</div>
						)}
						{!item.hasThumb && (
							<div
								onClick={() => setIsFileOpen(true)}
								className={styles.noThumbnail}>
								<i className={joinClasses(['fa fa-file', styles.fa])} />{' '}
								{item.name}
							</div>
						)}
						<div className={styles.itemControls}>
							{isShareMode && (
								<Checkbox value={isSelected} onChange={handleCheck} />
							)}
							{canBeEdited && (
								<LinkButton
									onClick={() => setIsEditOpen(true)}
									title={'base.shared.edit'}
									theme={Theme.BLUE}
								/>
							)}
						</div>
					</div>
				)}
				{item.avResult !== 'clean' && (
					<div className={styles.wrapper}>
						<div className={styles.noThumbnail}>
							<AntivirusCheck />
						</div>
						<div className={styles.itemControls}>
							<LinkButton
								onClick={() => null}
								title={'base.shared.edit'}
								theme={Theme.DISABLED}
							/>
						</div>
					</div>
				)}
			</div>
			{isEditOpen && (
				<EcardEditFileModal
					opened
					onClose={() => setIsEditOpen(false)}
					patientId={item.userId}
					item={item}
					onUpdate={reloadData}
				/>
			)}
			{isFileOpen && !hasGroupFiles && (
				<MediaViewerModal
					opened
					onClose={() => setIsFileOpen(false)}
					file={prepareDocumentationFileForMediaViewer(item, socketUrl)}
					isSignable={item.canBeSigned || false}
				/>
			)}
			{isFileOpen && hasGroupFiles && (
				<MultiMediaViewerModal
					files={item.groupFiles as IMultiMediaViewerItem[]}
					isOpen
					onClose={() => setIsFileOpen(false)}
				/>
			)}
		</>
	);
};

export default ECardGridItem;
